import { render, staticRenderFns } from "./SentimentPieChart.vue?vue&type=template&id=779419ea&"
import script from "./SentimentPieChart.vue?vue&type=script&lang=js&"
export * from "./SentimentPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports